<script>
import { useFaqsStore } from '../pinia/FaqsStore'
import { mapActions } from 'pinia'

export default {
  props: {
    faqsData: {
      type: Array,
      default: null
    },
    categoriesData: {
      type: Array,
      default: null
    },
  },
  mounted () {
    this.setupFaqs()
  },
  methods: {
    ...mapActions(useFaqsStore, [
      'setFaqs'
    ]),
    setupFaqs () {
      this.setFaqs(this.faqsData, this.categoriesData)
    }
  }
}
</script>
